import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BackendService } from './backend.service';
import { CreateVolunteerParams } from '../models';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  baseUrl = `${environment.baseUrl}/`;

  constructor(private backendService: BackendService) {}

  public subscribeToMailing(userDetails: any): Observable<any> {
    return this.backendService.post(`${this.baseUrl}mailing/list/email/`, userDetails).pipe(map((res) => res));
  }

  volunteerRegistration(data: CreateVolunteerParams): Observable<any> {
    return this.backendService.post(`${this.baseUrl}volunteers/`, data).pipe(
      map((res) => res),
      catchError((errorRes) => throwError(errorRes)),
    );
  }
}
